import {AuthenticationRepository} from "../../../repositories/AuthenticationRepository";

export class SignInWithMagicLinkUseCase {
  constructor(private readonly repository: AuthenticationRepository) {}

  isMagicLinkSignIn(url: string) {
    return this.repository.isMagicLinkSignIn(url)
  }

  get storedEmailForMagicLinkSignIn() {
    return this.repository.storedEmailForMagicLinkSignIn
  }

  signInWithMagicLink(email: string, url: string) {
    return this.repository.signInWithMagicLink(email, url)
  }
}
